import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Canonical host redirect — enforce verhuismatch.com in production
if (typeof window !== "undefined") {
  const { hostname, protocol, pathname, search, hash } = window.location;
  if (hostname === "www.verhuismatch.com") {
    window.location.replace(
      `https://verhuismatch.com${pathname}${search}${hash}`
    );
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
